"use strict";
/*
 * Created on 1. 11. 2018
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DomainObject_1 = require("../../../core/model/DomainObject");
/**
 * Input for evaluation of alerts for optimal price.
 * @author Radek Beran
 */


var OptimalPriceAlertsInput =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(OptimalPriceAlertsInput, _DomainObject_1$Domai);

  /**
   * @param optimalPriceValue value of optimal price
   * @param family family of product if product is in a family
   * @param familyLeaderOptimalPrice optimal price for family leader (if any exists)
   * @param rules price calculation rules/constraints from release settings; if settings are defined
   * @param releaseItem release item with reference price, purchase price filled
   * @param priceZoneId id of price zone
   */
  function OptimalPriceAlertsInput(optimalPriceValue, family, familyLeaderOptimalPrice, rules, releaseItem, priceZoneId) {
    var _this;

    _classCallCheck(this, OptimalPriceAlertsInput);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(OptimalPriceAlertsInput).call(this));
    _this.optimalPriceValue = optimalPriceValue;
    _this.family = family;
    _this.familyLeaderOptimalPrice = familyLeaderOptimalPrice;
    _this.rules = rules;
    _this.releaseItem = releaseItem;
    _this.priceZoneId = priceZoneId;
    return _this;
  }

  return OptimalPriceAlertsInput;
}(DomainObject_1.DomainObject);

exports.OptimalPriceAlertsInput = OptimalPriceAlertsInput;